import { Avatar, AvatarGroup } from "@mui/material";
import { useChatContext, useMessageContext } from "stream-chat-react";
import { useDisclosedNameResolver } from "Hooks/Chat/useDisclosedNameResolver";
import { Resources, useResource } from "Translations/Resources";

const AVATAR_SIZE = 16;
const MAX_AVATARS = 4;

/**
 * The "read by" part of an own message's status: the readers' avatars in a row, in place of the
 * SDK's single avatar plus a bare count that reads as a mystery number in a group. The SDK keeps
 * deciding WHEN the message counts as read (ChatMessageStatus); this only draws the readers.
 * Names are resolved per viewer (ADR-0007) for the tooltip and the accessible label.
 */
export const ChatMessageReadStatus = () => {
  const { t } = useResource();
  const { client } = useChatContext();
  const { readBy = [] } = useMessageContext();
  const resolveName = useDisclosedNameResolver();

  const readers = readBy.filter(({ id }) => id !== client.user?.id);
  if (readers.length === 0) {
    return null;
  }

  const names = readers.map(({ id, name }) => resolveName(id, name) ?? id);
  const label = t(Resources.Chat.ReadBy, { count: readers.length });

  return (
    <AvatarGroup
      max={MAX_AVATARS}
      role="img"
      aria-label={label}
      title={names.join(", ")}
      sx={{
        "& .MuiAvatar-root": {
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          fontSize: 9,
          borderWidth: 1,
        },
      }}
    >
      {readers.map(({ id, image }, index) => (
        <Avatar key={id} src={image} alt={names[index]} />
      ))}
    </AvatarGroup>
  );
};
